export const promisesSponsorshipsFragment = `
participantPromisesSponsorships {
    donorFirstName
    pdefProgramFundSourceTypeDescription
    promisedAmount
    donorConstituentId
    donorLastName
    includedInTotal
    frTotalFlag
    participantDistributions {
      fundraiserPageDisplayAmountType {
        fundraiserPageDisplayAmountTypeId
        name
        description
      }
      fundraiserPageDisplayDonorType {
        fundraiserPageDisplayDonorTypeId
        name
        description
      }
      donorAddress1
      fundType
      participantFundsId
      donorMessageId
      donorState
      donorMatchingCompanyName
      status
      fundDate
      donorEmail
      donorCountry
      amount
      donorAddress2
      donorPhoneNumber
      paymentMethod
      companyMatching
      participantDistributionsId
      donorPostalCode
      donationDescription
      donorMessage
      donorName
      donorAreaCode
      recurringFlag
      donorCity
      source
      honoree
      thankYouNoteSent
      donorDisplayName
      type
      showComments
      hasDcf
    }
    participantPromisesSponsorshipsId
    donorName
    emgmtOcpFundraiserId
    pdefProgramFundSourceTypeName
    promisedDate
}
`;
